export default class DistributionDS {
  constructor (data, labels, distributionFactor) {
    this.distribution = {
      data,
      labels
    }
    this.labels = []
    this.data = []
    this.distributionFactor = distributionFactor
  }

  getDistribution (distributionLabel, rest) {
    let offsetFactor = this.distributionFactor - 1
    this.dataSum = 0
    this.dataLabel = ''
    let i = 0
    let length = this.distribution.data.length
    let data = null
    let label = null
    for (; i < length; i++) {
      data = this.distribution.data[i]
      label = this.distribution.labels[i]
      this.dataSum += data
      if (i % this.distributionFactor === 0) {
        this.dataLabel = label
      }
      if (i % this.distributionFactor === offsetFactor) {
        this.setData(label)
      }
    }
    if (i % this.distributionFactor !== offsetFactor - 1) {
      this.setData(label)
    }
    return {
      labels: this.labels,
      datasets: [{
        label: distributionLabel,
        data: this.data,
        ...rest
      }]
    }
  }

  setData (label) {
    this.dataLabel += ' - ' + label
    this.data.push(this.dataSum)
    this.labels.push(this.dataLabel)
    this.dataSum = 0
    this.dataLabel = ''
  }
}



// WEBPACK FOOTER //
// ./src/app/common/datastructures/DistributionDS.js